import isCore from 'common/util/isCore';
import isFree from 'common/util/isFree';
import isStarter from 'common/util/isStarter';

/** Pro trial can only be started if:
 * 1. The company's last trial was anything except for core
 * 2. The company is on an expired, free or core plan
 * */
export const canStartProTrial = (planID: string | undefined, trialPlanID: string | undefined) => {
  const hasDoneNonCoreTrial = trialPlanID && !isCore(trialPlanID);
  if (hasDoneNonCoreTrial) {
    return false;
  }

  // only allow on expired, free plan, or core plan
  const planExpired = !planID;
  const onFree = planID && isFree(planID);
  const onCore = planID && isCore(planID);
  const onValidPlan = planExpired || onFree || onCore;
  if (!onValidPlan) {
    return false;
  }

  return true;
};

/** Core trial can only be started if:
 * 1. The company has not previously done a trial
 * 2. The company is on an expired or free plan
 * */
export const canStartCoreTrial = (planID: string | undefined, trialPlanID: string | undefined) => {
  const hasDoneAnyTrial = !!trialPlanID;
  if (hasDoneAnyTrial) {
    return false;
  }

  // only allow on expired or free plan
  const planExpired = !planID;
  const onFree = planID && isFree(planID);
  const onValidPlan = planExpired || onFree;
  if (!onValidPlan) {
    return false;
  }

  return true;
};

/** Growth trial can only be started if:
 * 1. The last trial was anything except for starter
 * 2. The company is on an expired, free or starter plan
 * */
export const canStartGrowthTrial = (
  planID: string | undefined,
  trialPlanID: string | undefined,
) => {
  const hasDoneNonStarterTrial = trialPlanID && !isStarter(trialPlanID);
  if (hasDoneNonStarterTrial) {
    return false;
  }

  // only allow on expired, free plan, or starter plan
  const planExpired = !planID;
  const onFree = planID && isFree(planID);
  const onStarter = planID && isStarter(planID);
  const onValidPlan = planExpired || onFree || onStarter;
  if (!onValidPlan) {
    return false;
  }

  return true;
};

/** Starter trial can only be started if:
 * 1. The company has not previously done a trial
 * 2. The company is on an expired or free plan
 * */
export const canStartStarterTrial = (
  planID: string | undefined,
  trialPlanID: string | undefined,
) => {
  const hasDoneAnyTrial = !!trialPlanID;
  if (hasDoneAnyTrial) {
    return false;
  }

  // only allow on expired or free plan
  const planExpired = !planID;
  const onFree = planID && isFree(planID);
  const onValidPlan = planExpired || onFree;
  if (!onValidPlan) {
    return false;
  }

  return true;
};
